/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import PropTypes from "prop-types";
import jwtDecode from "jwt-decode";
import {
  removeFromCartReduxStore,
  addToCartReduxStore,
  updateCartCustomer,
  updateStatusAuthenticatedUserBooking,
  checkCustomerIsUpdated,
  checkBookingPayment,
  reportCartTimeout
} from "../../../actions/admin/booking";
import { getUserDetail, updatePaymentInfo } from "../../../actions/auth";
import { flywireSuccessPayment } from "../../../actions/admin/flywire"
import {
  getLocationByAddress,
  translate
} from "../../../actions/googleAPI";
import { useLoading } from "../../../components/LoadingContext";
import ReactTooltip from "react-tooltip";
import CheckoutConfirmationModal from "./_components/CheckoutConfirmationModal";
import MultiTotalCard from "../../../components/total-card/MultiTotalCard";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, ScrollProgressBar, pressable } from "../../../components/motion";
import CountryCodePicker from "../../../components/input/input-register/CountryCodePicker";
import useCountries from "../../../components/input/input-register/useCountries";
import {
  POSTAL_CODE_STATUS,
  PostalCodeStatusIcon,
  PostalCodeStatusMessage,
  usePostalCodeLookup,
} from "../../../components/input/postal-code";
import { pushEventGTM } from "../../../utils/gtm";
import { sortCartByTravelDate } from "../../../utils/cartSort";
import AlertModal from "../../../components/AlertModal";
import { additionalCardValidation } from "../../../utils/flywire";
import Clock from "../cart/_components/Clock";
import {
  AddIcon,
  ArrowRightIcon,
  ClockAltIcon
} from "../../../components/icons"

const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/visa-icon.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/jcb-icon.svg";
const diners_club_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/diners-club-icon.svg";
const amex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/amex-icon.svg";
const discover_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/discover-icon.svg";
const maestro_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/maestro-icon.svg";
const master_card_icon_opt = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/master-card.svg";
const american_ex_icon_opt = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/american_ex.svg";
const jcb_icon_opt = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/jcb.svg";
const visa_icon_opt = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/visa.svg";

const NewCheckout = (props, isAuthenticated) => {
  const itemsToCheckoutRaw = props.location.state?.items_to_checkout || [];
  const fromCart = props.location.state?.fromCart || false;

  const formCheckoutRef = useRef(null);
  const handleScrollFormValidation = () => {
    formCheckoutRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const { showLoading, closeLoading } = useLoading();

  const dispatch = useDispatch();
  const [itemsToCheckout,] = useState(
    itemsToCheckoutRaw.length > 0
      ? JSON.parse(itemsToCheckoutRaw)
      : itemsToCheckoutRaw
  );

  // Checkout items shown on screen, ordered by travel date (earliest first).
  // Only used for display — `itemsToCheckout` keeps its original order for payment and saving.
  const sortedItemsToCheckout = useMemo(
    () => sortCartByTravelDate(itemsToCheckout),
    [itemsToCheckout]
  );

  const validationErrors = [];

  const [firstnamev, setfirstnamev] = useState("");
  const [lastnamev, setlastnamev] = useState("");
  const [emailv, setemailv] = useState("");
  const [phonev, setphonev] = useState("");
  const [addressv, setaddressv] = useState("");
  const [postcodev, setpostcodev] = useState("");
  const [postcodeNotFoundv, setpostcodeNotFoundv] = useState("");
  const [countryv, setcountryv] = useState("");
  const [customerData, setCustomerData] = useState({
    pronounced: "Mr.",
    name: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    postCode: "",
    city: "",
    country: "Japan",
    userId: "",
    country_code: "JP",
    prefix_number: "+81",
  });

  const [isTermsChecked, setIsTermsChecked] = useState(false);
  // Shared, cached country list (also re-runs the saved-account prefill below once loaded).
  const countriesData = useCountries();
  const [countryCode, setCountryCode] = useState("JP");
  const [prefixPhoneNumber, setPrefixPhoneNumber] = useState("+81");
  const [openDropdown, setOpenDropdown] = useState(null);
  const countryWithoutPostCodeList = (process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE || "").split(",");
  const isPostalCodeDisabled = countryWithoutPostCodeList.includes(customerData.country_code);
  const isCityDisabled = !isPostalCodeDisabled;
  useEffect(() => {
    const closeDropdowns = (e) => {
      if (!e.target.closest("[data-dropdown]")) setOpenDropdown(null);
    };
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);

  const [showInvalidCardValidation, setShowInvalidCardValidation] = useState(false);

  const handleInvalidCardClose = () => setShowInvalidCardValidation(false);

  const history = useHistory();


  const handleTermsCheckboxChange = () => {
    setIsTermsChecked(!isTermsChecked); // Toggle the checkbox status
  };

  const handleLiClickCountryList = (dialCode, countryCode, name) => {
    setPrefixPhoneNumber(dialCode);
    setCountryCode(countryCode);
    setCustomerData({
      ...customerData,
      country: name,
      country_code: countryCode,
      prefix_number: dialCode,
      postCode: "",
      city: "",
    });
    setpostcodev("");
    setpostcodeNotFoundv("");
  };

  // Postal code: checked against the geocoding endpoint as the user types
  // (spinner + "Checking postal code…" while it runs, retry if it fails).
  const postalCodeLookup = usePostalCodeLookup({
    postalCode: customerData.postCode?.trim(),
    countryCode: customerData.country_code,
    isEnabled: !isPostalCodeDisabled,
    onFound: (city) => {
      setpostcodeNotFoundv("");
      setCustomerData((prev) => ({ ...prev, city }));
    },
    onNotFound: () => {
      setpostcodeNotFoundv("invalid");
      setCustomerData((prev) => ({ ...prev, city: "" }));
    },
  });
  const isCheckingPostalCode = postalCodeLookup.status === POSTAL_CODE_STATUS.CHECKING;

  const onChangeForm = (e) => {
    if (["firstName", "lastName", "address", "city"].includes(e.target.name)) {
      const filteredValue = e.target.value.replace(/[^\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/g, "")
      const updatedData = {
        ...customerData,
        [e.target.name]: filteredValue,
      };
      if (e.target.name === "firstName" || e.target.name === "lastName") {
        updatedData.name = `${updatedData.firstName} ${updatedData.lastName}`.trim();
      }
      setCustomerData(updatedData);
    } else {
      setCustomerData({
        ...customerData,
        [e.target.name]: e.target.value,
      });
    }
    if (e.target.name === "firstName") setfirstnamev("");
    if (e.target.name === "lastName") setlastnamev("");
    if (e.target.name === "email") setemailv("");
    if (e.target.name === "phone") setphonev("");
    if (e.target.name === "address") setaddressv("");
    if (e.target.name === "postCode") setpostcodev("");
    if (e.target.name === "country") setcountryv("");
    if (e.target.name === "country_code") setcountryv("");
    if (e.target.name === "prefix_number") setcountryv("");
  };

  const validateForms = () => {
    let isValid = true;

    if (customerData.firstName === "" || customerData.firstName.trim() === "") {
      setfirstnamev("is-invalid-empty");
      isValid = false;
    }

    if (customerData.lastName === "" || customerData.lastName.trim() === "") {
      setlastnamev("is-invalid-empty");
      isValid = false;
    }

    if (
      customerData.firstName.trim() !== "" &&
      customerData.lastName.trim() !== "" &&
      customerData.name.trim().length < 3
    ) {
      setfirstnamev("is-invalid-min");
      isValid = false;
    }

    if (customerData.email === "" || customerData.email.trim() === "") {
      setemailv("is-invalid-empty");
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(customerData.email)) {
        setemailv("is-invalid-format");
        isValid = false;
      }
    }

    if (customerData.phone === "" || customerData.phone.trim() === "") {
      setphonev("is-invalid");
      isValid = false;
    }

    // Validate address (not empty)
    if (customerData.address === "" || customerData.address.trim() === "") {
      setaddressv("is-invalid");
      isValid = false;
    }

    // Validate postal code (not empty for countries that require it)
    if (customerData.postCode === "" || customerData.postCode.trim() === "") {
      const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

      if (!countryWithoutPostCode.split(',').includes(customerData.country_code)) {
        setpostcodev("is-invalid");
        isValid = false;
      }
    }

    // Validate country
    if (customerData.country === "") {
      setcountryv("is-invalid");
      isValid = false;
    }

    return isValid;
  };

  const callbackFlywire = async (result, ref, countryCode) => {
    const cardValid = await additionalCardValidation(result, countryCode);
    if (cardValid) {
      result.ref = ref

      if (result.status === "success") {
        const cart_id = itemsToCheckout[0].cartID === undefined ? itemsToCheckout[0].cartID : itemsToCheckout[0].cartID;

        const updateSuccessBooking = await flywireSuccessPayment(result);

        closeLoading(true);
        if (updateSuccessBooking.status === 200 && updateSuccessBooking.data.status === "SUCCESS") {
          history.push(`/PaymentSuccess/${cart_id}`);
        }
      }
    } else {
      setShowInvalidCardValidation(true);
    }
  }

  const callbackFlywireAuthenticatedUser = async (result, ref, countryCode) => {
    const cardValid = await additionalCardValidation(result, countryCode);
    if (cardValid) {
      result.ref = ref

      if (result.status === "success") {
        const cart_id = itemsToCheckout[0].cartID === undefined ? itemsToCheckout[0].cartID : itemsToCheckout[0].cartID;

        const addPaymentMethodUser = await updatePaymentInfo(result);

        closeLoading(true);
        if (addPaymentMethodUser.status === "SUCCESS") {
          const updateSuccessBooking = await flywireSuccessPayment(result);

          if (updateSuccessBooking.status === 200 && updateSuccessBooking.data.status === "SUCCESS") {
            history.push(`/PaymentSuccess/${cart_id}`);
          }
        }
      }
    } else {
      setShowInvalidCardValidation(true);
    }
  }

  const extractFirstAndLastName = async (fullName) => {
    // Split the full name into an array of strings
    const nameParts = fullName.trim().split(' ');

    // Extract the first name (first element of the array)
    const firstName = nameParts[0];

    // Extract the last name (last element of the array, if exists)
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '';

    // Return an object containing the first name and last name
    return {
      firstName: firstName,
      lastName: lastName ? lastName : firstName,
    };
  }

  const [checkoutConfirmationShow, setCheckoutConfirmationShow] = useState(false);

  const handleCheckoutConfirmationShow = () => setCheckoutConfirmationShow(true);
  const handleCheckoutConfirmationClose = () => setCheckoutConfirmationShow(false);
  const handleCheckoutConfirmationNext = () => {
    setCheckoutConfirmationShow(false);
    clickProceedToPayment();
  };

  const clickProceedToPayment = async () => {
    if (validateForms()) {
      showLoading(true);
      var config;
      var modal;
      if (isTermsChecked) {
        if (validationErrors.length === 0) {
          const cart_id = itemsToCheckout[0].cartID;

          const checkBookingPaymentResult = await checkBookingPayment(cart_id);

          if (checkBookingPaymentResult.status === "ELIGIBLE") {
            await fetchUpdateBookingCustomer(
              itemsToCheckout,
              customerData
            );

            const customer_status = await checkCustomerIsUpdated(cart_id);

            const zipCodeCheck = await getLocationByAddress(customerData.postCode, customerData.country_code);

            const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

            if (zipCodeCheck === undefined && !countryWithoutPostCode.split(',').includes(customerData.country_code)) {
              handleScrollFormValidation();
              setpostcodeNotFoundv("invalid");
              closeLoading(true);
              return;
            }

            let city
            if (customerData.city && customerData.city.trim() !== "") {
              city = customerData.city.trim()
            } else if (countryWithoutPostCode.split(',').includes(customerData.country_code)) {
              city = customerData.country
            } else if (zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality")).length !== 0) {
              const cityComponent = zipCodeCheck.address_components.find(
                (item) =>
                  item.types.includes("administrative_area_level_2") ||
                  item.types.includes("locality")
              );

              city = cityComponent ? cityComponent.long_name : null;
            } else {
              city = zipCodeCheck.address_components[zipCodeCheck.address_components.length - 2].long_name
            }

            if (zipCodeCheck || countryWithoutPostCode.split(',').includes(customerData.country_code)) {
              const { firstName, lastName } = await extractFirstAndLastName(customerData.name);

              if (customer_status) {
                if (itemsToCheckout) {
                  if (fromCart) {
                    updateCartItem(itemsToCheckout);
                  }

                  if (customerData.role === "individual" || customerData.role === "business") {
                    const userDetail = await getUserDetail(customerData.userId);
                    const accountDetail = userDetail[customerData.role === "individual" ? "individualDetail" : "businessDetail"];

                    if (selectedPaymentMethod !== "") {
                      const responseUpdate = await fetchUpdateBookingAuthenticatedUser({
                        cart: itemsToCheckout,
                        customerInfo: customerData,
                        statusBooking: "CONFIRMED",
                        statusPayment: "CHARGE_PENDING",
                        paymentMethod: selectedPaymentMethod
                      });

                      itemsToCheckout.map((val) => {
                        const items = [];
                        let totalPrice = 0;

                        val.bookingInfo.map((bi, ind) => {
                          const item = {
                            index: ind,
                            item_id: bi.vehicleTypeID,
                            item_name: bi.vehicleTypeName,
                            item_brand: "Toyota",
                            affiliation: "Flywire",
                            coupon: "",
                            discount: 0,
                            item_category: val.bookingType === "byTheHour" ? 'By The Hour' : val.isAirportTransfer ? 'Airport Transfer' : 'Specified Destination',
                            item_category2: val.destinations.length === 1 ? val.destinations[0].place_id : val.destinations[val.destinations.length - 1].place_id,
                            item_category3: (bi.childSeat[0].childSeatCount + bi.childSeat[1].childSeatCount + bi.childSeat[2].childSeatCount) > 0 ? "Child Seats" : "",
                            location_id: "",
                            price: bi.total,
                            quantity: 1,
                          };

                          items.push(item);
                        })

                        totalPrice = val.totalPrice

                        const ecommerceData = {
                          currency: "JPY",
                          value: totalPrice,
                          items: items
                        }

                        pushEventGTM({
                          event: 'add_payment_info',
                          ecommerce: ecommerceData
                        });
                      })

                      closeLoading(true);
                      if (responseUpdate.status === 200) {
                        history.push(`/PaymentSuccess/${itemsToCheckout[0].cartID}`);
                      }
                    } else {
                      const regex = /[\u4E00-\u9FFF\u3040-\u30FF\uFF66-\uFF9F]/
                      const checkAddressContainsJapanese = regex.test(accountDetail.billingInformation.address);
                      var finalAddress
                      if (checkAddressContainsJapanese) {
                        const translateResult = await translate("en", accountDetail.billingInformation.address)

                        finalAddress = translateResult.translatedText.replace("〒", "");
                      } else {
                        finalAddress = accountDetail.billingInformation.address;
                      }

                      config = {
                        env: process.env.REACT_APP_FLYWIRE_ENV,
                        recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

                        // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
                        amount: 0,
                        //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
                        recurringType: "tokenization",
                        recurringTypeRecipientCodes: [
                          process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
                          process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
                        ],
                        locale: lang === "JP" ? "ja" : "en",

                        // Specify the returnUrl or an onCompleteCallback handler
                        // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

                        // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
                        firstName: firstName,
                        lastName: lastName,
                        email: customerData.email,
                        phone: accountDetail.billingInformation.prefix_number + " " + accountDetail.billingInformation.phone,
                        address: finalAddress,
                        city: city,
                        zip: customerData.postCode,
                        country: accountDetail.billingInformation.country_code,

                        recipientFields: {
                          booking_reference: `CB-${cart_id}`,
                          additional_information: null,
                        },

                        requestPayerInfo: false,
                        requestRecipientInfo: false,

                        // Control which tokenization options are available
                        paymentOptionsConfig: {
                          filters: {
                            type: ["credit_card"]
                          }
                        },
                        onCompleteCallback: function (args) {
                          callbackFlywireAuthenticatedUser(args, `CB-${cart_id}`, accountDetail.billingInformation.country_code);
                        },
                        onInvalidInput: function (errors) {
                          errors.forEach(function (error) {
                            console.log(error.msg);
                          });
                        }
                      };

                      itemsToCheckout.map((val) => {
                        const items = [];
                        let totalPrice = 0;

                        val.bookingInfo.map((bi, ind) => {
                          const item = {
                            index: ind,
                            item_id: bi.vehicleTypeID,
                            item_name: bi.vehicleTypeName,
                            item_brand: "Toyota",
                            affiliation: "Flywire",
                            coupon: "",
                            discount: 0,
                            item_category: val.bookingType === "byTheHour" ? 'By The Hour' : val.isAirportTransfer ? 'Airport Transfer' : 'Specified Destination',
                            item_category2: val.destinations.length === 1 ? val.destinations[0].place_id : val.destinations[val.destinations.length - 1].place_id,
                            item_category3: (bi.childSeat[0].childSeatCount + bi.childSeat[1].childSeatCount + bi.childSeat[2].childSeatCount) > 0 ? "Child Seats" : "",
                            location_id: "",
                            price: bi.total,
                            quantity: 1,
                          };

                          items.push(item);
                        })

                        totalPrice = val.totalPrice

                        const ecommerceData = {
                          currency: "JPY",
                          value: totalPrice,
                          items: items
                        }

                        pushEventGTM({
                          event: 'add_payment_info',
                          ecommerce: ecommerceData
                        });
                      })

                      closeLoading(true);
                      modal = window.FlywirePayment.initiate(config);
                      modal.render();
                    }
                  } else {
                    const regex = /[\u4E00-\u9FFF\u3040-\u30FF\uFF66-\uFF9F]/
                    const checkAddressContainsJapanese = regex.test(customerData.address);
                    var finalAddress
                    if (checkAddressContainsJapanese) {
                      const translateResult = await translate("en", customerData.address)

                      finalAddress = translateResult.translatedText.replace("〒", "");
                    } else {
                      finalAddress = customerData.address;
                    }

                    config = {
                      env: process.env.REACT_APP_FLYWIRE_ENV,
                      recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

                      // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
                      amount: 0,
                      //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
                      recurringType: "tokenization",
                      recurringTypeRecipientCodes: [
                        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
                        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
                      ],
                      locale: lang === "JP" ? "ja" : "en",

                      // Specify the returnUrl or an onCompleteCallback handler
                      // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

                      // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
                      firstName: firstName,
                      lastName: lastName,
                      email: customerData.email,
                      phone: customerData.prefix_number + " " + customerData.phone,
                      address: finalAddress,
                      city: city,
                      zip: countryWithoutPostCode.split(',').includes(customerData.country_code) ? "0000" : customerData.postCode,

                      country: customerData.country_code,

                      recipientFields: {
                        booking_reference: `CB-${cart_id}`,
                        additional_information: null,
                      },

                      requestPayerInfo: false,
                      requestRecipientInfo: false,

                      // Control which tokenization options are available
                      paymentOptionsConfig: {
                        filters: {
                          type: ["credit_card"]
                        }
                      },
                      onCompleteCallback: function (args) {
                        callbackFlywire(args, `CB-${cart_id}`, customerData.country_code);
                      },
                      onInvalidInput: function (errors) {
                        errors.forEach(function (error) {
                          console.log(error.msg);
                        });
                      }
                    };

                    closeLoading(true);
                    modal = window.FlywirePayment.initiate(config);
                    modal.render();
                  }
                }
              } else {
                closeLoading(true);
                console.log("An unexpected error occured. -> User not updated yet");
              }
            } else {
              setpostcodev("invalid");
              closeLoading(true);
            }
          } else {
            closeLoading(true);
            console.log("NOT ELIGIBLE")
          }
        } else {
          closeLoading(true);
          console.log("An unexpected error occured.");
        }
      }
    } else {
      handleScrollFormValidation();
    }

  };



  useEffect(() => {
    try {
      if (itemsToCheckout.length === 0) {
        history.push("../Cart");
      } else {
        itemsToCheckout.map((val) => {
          const items = [];
          let totalPrice = 0;

          val.bookingInfo.map((bi, ind) => {
            const item = {
              index: ind,
              item_id: bi.vehicleTypeID,
              item_name: bi.vehicleTypeName,
              item_brand: "Toyota",
              affiliation: "Flywire",
              coupon: "",
              discount: 0,
              item_category: val.bookingType === "byTheHour" ? 'By The Hour' : val.isAirportTransfer ? 'Airport Transfer' : 'Specified Destination',
              item_category2: val.destinations.length === 1 ? val.destinations[0].place_id : val.destinations[val.destinations.length - 1].place_id,
              item_category3: (bi.childSeat[0].childSeatCount + bi.childSeat[1].childSeatCount + bi.childSeat[2].childSeatCount) > 0 ? "Child Seats" : "",
              location_id: "",
              price: bi.total,
              quantity: 1,
            };

            items.push(item);
          })

          totalPrice = val.totalPrice

          const ecommerceData = {
            currency: "JPY",
            value: totalPrice,
            items: items
          }

          pushEventGTM({
            event: "add_shipping_info",
            ecommerce: ecommerceData
          });
        })
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const token = localStorage.getItem("token");
      if (token) {
        const decodedJwt = jwtDecode(token);
        if (token && decodedJwt.user.role === "individual" || decodedJwt.user.role === "business") {
          const accountDetail = decodedJwt?.user?.id[decodedJwt.user.role === "individual" ? "individualDetail" : "businessDetail"]

          const billingName = accountDetail.billingInformation.name || "";
          const [billingFirstName, ...billingLastNameParts] = billingName.trim().split(" ");

          setCustomerData({
            pronounced: accountDetail.billingInformation.pronounced,
            name: billingName,
            firstName: billingFirstName || "",
            lastName: billingLastNameParts.join(" "),
            email: decodedJwt.user.id.email,
            phone: accountDetail.billingInformation.phone,
            address: accountDetail.billingInformation.address,
            postCode: accountDetail.billingInformation.postal_code,
            city: accountDetail.billingInformation.city || "",
            country: accountDetail.billingInformation.country,
            country_code: accountDetail.billingInformation.country_code,
            userId: decodedJwt.user.id._id,
            prefix_number: accountDetail.billingInformation.prefix_number,
            role: decodedJwt.user.role
          });
          setPrefixPhoneNumber(
            accountDetail.billingInformation.prefix_number
          );
          setCountryCode(
            accountDetail.billingInformation.country_code
          );
        }
      }
    }
  }, [countriesData]);

  const fetchUpdateBookingCustomer = async (
    s_cart,
    customerInfo
  ) => {
    await updateCartCustomer(
      s_cart,
      customerInfo
    );
  };

  const debouncedUpdateStatus = _.debounce(async (reqBody, resolve) => {
    const resp = await updateStatusAuthenticatedUserBooking(reqBody);
    resolve(resp);
  }, 500); // adjust delay as needed

  const fetchUpdateBookingAuthenticatedUser = (reqBody) => {
    return new Promise((resolve) => {
      debouncedUpdateStatus(reqBody, resolve);
    });
  };

  const updateCartItem = async (item) => {
    if (localStorage.getItem("cart") !== null) {
      dispatch(addToCartReduxStore(itemsToCheckout));
      localStorage.setItem("cart", JSON.stringify(itemsToCheckout));
      dispatch(removeFromCartReduxStore(itemsToCheckout));
    } else {
      window.location.reload();
    }
  };

  const contentRef = useRef(null);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  useEffect(() => {
    const contentDiv = contentRef.current;

    function handleScroll() {
      // Check if the user has scrolled to the bottom
      if (
        contentDiv.scrollTop + contentDiv.clientHeight >=
        contentDiv.scrollHeight - 10
      ) {
        setIsScrolledToBottom(true);
      }
    }

    contentDiv.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      contentDiv.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [isAuthChecked, setIsAuthChecked] = useState(false);


  const checkIsAuthUser = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedJwt = jwtDecode(token);
      if (token && decodedJwt.user.role === "individual" || decodedJwt.user.role === "business") {
        const userDetail = await getUserDetail(decodedJwt.user.id._id);
        const accountDetail = userDetail[decodedJwt.user.role === "individual" ? "individualDetail" : "businessDetail"];
        setPaymentMethods(accountDetail?.paymentMethod)
        const paymentMethodActive = accountDetail?.paymentMethod?.find(item => item.isActive);
        setSelectedPaymentMethod(paymentMethodActive?._id || "");
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    const init = async () => {
      const result = await checkIsAuthUser();
      setIsAuthChecked(result);
    };
    init();
  }, []); // run once on mount

  function getCardTypeByBrand(type) {

    if (type === "VISA") {
      return visa_icon_opt;
    } else if (type === "MASTERCARD") {
      return master_card_icon_opt;
    } else if (type === "AMERICAN EXPRESS") {
      return american_ex_icon_opt;
    } else if (type === "JCB") {
      return jcb_icon_opt;
    }

    return "Unknown"; // If none of the patterns match
  }

  function convertToMMYYYY(input) {
    // Check if the input string has a length of 4 and contains only digits
    if (/^\d{4}$/.test(input)) {
      const month = input.slice(0, 2);
      const year = input.slice(2);
      return `${month}/${year}`;
    } else {
      // Handle invalid input
      return "Invalid input";
    }
  }

  const callbackFlywireAddPaymentMethod = async (result, ref, countryCode) => {
    const cardValid = await additionalCardValidation(result, countryCode);
    if (cardValid) {
      result.ref = ref

      if (result.status === "success") {
        const cart_id = itemsToCheckout[0].cartID === undefined ? itemsToCheckout[0].cartID : itemsToCheckout[0].cartID;

        const addPaymentMethodUser = await updatePaymentInfo(result);

        closeLoading(true);
        if (addPaymentMethodUser.status === "SUCCESS") {
          const result = await checkIsAuthUser();
          setIsAuthChecked(result);
        }
      }
    } else {
      setShowInvalidCardValidation(true);
    }

  }

  const addPaymentMethodHandler = async () => {
    if (validateForms()) {
      showLoading(true);
      let config;
      let modal;
      if (validationErrors.length === 0) {
        const cart_id = itemsToCheckout[0].cartID;
        const checkBookingPaymentResult = await checkBookingPayment(cart_id);

        if (checkBookingPaymentResult.status === "ELIGIBLE") {
          await fetchUpdateBookingCustomer(
            itemsToCheckout,
            customerData
          );

          const customer_status = await checkCustomerIsUpdated(cart_id);

          const zipCodeCheck = await getLocationByAddress(customerData.postCode, customerData.country_code);

          const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

          if (zipCodeCheck === undefined && !countryWithoutPostCode.split(',').includes(customerData.country_code)) {
            handleScrollFormValidation();
            setpostcodeNotFoundv("invalid");
            closeLoading(true);
            return;
          }

          let city
          if (customerData.city && customerData.city.trim() !== "") {
            city = customerData.city.trim()
          } else if (countryWithoutPostCode.split(',').includes(customerData.country_code)) {
            city = customerData.country
          } else if (zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality")).length !== 0) {
            const cityComponent = zipCodeCheck.address_components.find(
              (item) =>
                item.types.includes("administrative_area_level_2") ||
                item.types.includes("locality")
            );

            city = cityComponent ? cityComponent.long_name : null;
          } else {
            city = zipCodeCheck.address_components[zipCodeCheck.address_components.length - 2].long_name
          }

          if (zipCodeCheck || countryWithoutPostCode.split(',').includes(customerData.country_code)) {
            const { firstName, lastName } = await extractFirstAndLastName(customerData.name);

            if (customer_status) {
              if (itemsToCheckout) {
                if (fromCart) {
                  updateCartItem(itemsToCheckout);
                }

                if (customerData.role === "individual" || customerData.role === "business") {
                  const userDetail = await getUserDetail(customerData.userId);
                  const accountDetail = userDetail[customerData.role === "individual" ? "individualDetail" : "businessDetail"];

                  const regex = /[\u4E00-\u9FFF\u3040-\u30FF\uFF66-\uFF9F]/
                  const checkAddressContainsJapanese = regex.test(accountDetail.billingInformation.address);
                  var finalAddress
                  if (checkAddressContainsJapanese) {
                    const translateResult = await translate("en", accountDetail.billingInformation.address)

                    finalAddress = translateResult.translatedText.replace("〒", "");
                  } else {
                    finalAddress = accountDetail.billingInformation.address;
                  }

                  config = {
                    env: process.env.REACT_APP_FLYWIRE_ENV,
                    recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

                    // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
                    amount: 0,
                    //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
                    recurringType: "tokenization",
                    recurringTypeRecipientCodes: [
                      process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
                      process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
                    ],
                    locale: lang === "JP" ? "ja" : "en",

                    // Specify the returnUrl or an onCompleteCallback handler
                    // returnUrl: process.env.REACT_APP_URL + "/PaymentSuccess/"+ cart_id,

                    // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
                    firstName: firstName,
                    lastName: lastName,
                    email: customerData.email,
                    phone: accountDetail.billingInformation.prefix_number + " " + accountDetail.billingInformation.phone,
                    address: finalAddress,
                    city: city,
                    zip: customerData.postCode,
                    country: accountDetail.billingInformation.country_code,

                    recipientFields: {
                      booking_reference: `CB-${cart_id}`,
                      additional_information: null,
                    },

                    requestPayerInfo: false,
                    requestRecipientInfo: false,

                    // Control which tokenization options are available
                    paymentOptionsConfig: {
                      filters: {
                        type: ["credit_card"]
                      }
                    },
                    onCompleteCallback: function (args) {
                      callbackFlywireAddPaymentMethod(args, `CB-${cart_id}`, accountDetail.billingInformation.country_code);
                    },
                    onInvalidInput: function (errors) {
                      errors.forEach(function (error) {
                        console.log(error.msg);
                      });
                    }
                  };

                  closeLoading(true);
                  modal = window.FlywirePayment.initiate(config);
                  modal.render();
                }
              }
            } else {
              closeLoading(true);
              console.log("An unexpected error occured. -> User not updated yet");
            }
          } else {
            setpostcodev("invalid");
            closeLoading(true);
          }
        } else {
          closeLoading(true);
          console.log("NOT ELIGIBLE")
        }
      } else {
        closeLoading(true);
        console.log("An unexpected error occured.");
      }
    } else {
      closeLoading(true);
      handleScrollFormValidation();
    }
  }

  const [clockRef, setClockRef] = useState(null);
  const lastAddedBookToCart = localStorage.getItem("lastAddedBookToCart");

  // The countdown belongs to the cart hold, so it only makes sense for a
  // checkout that came from the cart. "Book this transfer only" sends the
  // booking straight here without ever putting it in the cart: the item carries
  // no hold anchor, so the clock fell back to the `lastAddedBookToCart` marker --
  // which is never cleared once set -- read it as long expired, and fired
  // onCompleteTimer on mount. That flagged the booking that had just been
  // created as timed out and bounced the customer to an empty cart page.
  const showCartCountdown = fromCart && itemsToCheckout.length > 0;

  const SettingClockRef = (ref) => {
    if (ref !== null) setClockRef(ref);
  };

  const startClock = () => {
    try {
      if (clockRef === null) return;
      clockRef.start();
    } catch (e) {
      console.error(e);
    }
  };

  const stopClock = () => {
    try {
      clockRef.stop();
    } catch { }
  };

  const onCompleteTimer = () => {
    // Flag the bookings before bouncing back to the cart. The cart page shows the
    // "your cart has expired" notice and clears local state; without this the
    // server-side bookings would linger unflagged until the next sweeper tick.
    const keys = (itemsToCheckout || [])
      .map((item) => item.key)
      .filter((key) => key !== undefined && key !== null);
    if (keys.length > 0) reportCartTimeout(keys);

    history.push("../Cart");
  };

  const checkoutButtonEligibility = () => {
    if (!isTermsChecked) return false;

    if (
      (customerData.role === "individual" || customerData.role === "business") &&
      (!paymentMethods || paymentMethods.length === 0)
    ) {
      return false;
    }

    return true;
  };

  const fieldLabelClass = "tw:block tw:text-[15px] tw:leading-[20px] tw:!text-[#282828] tw:font-[400] tw:mb-2 tw:[font-family:var(--font-sans-primary)]";
  const fieldInputClass = "tw:block tw:w-full tw:h-12 tw:text-[15px] tw:!font-[400] tw:leading-normal tw:text-[#4e4e4e] tw:bg-white tw:border tw:border-[#f1f1f1] tw:rounded-[0.3rem] tw:py-[0.375rem] tw:px-4 tw:[font-family:var(--font-sans-primary)] tw:placeholder:text-[#a7a7a7] tw:transition-[border-color,box-shadow] tw:duration-200 tw:focus:border-[#DBBE78] tw:focus:outline-none tw:focus:shadow-[0_0_0_3px_rgba(219,190,120,0.18)] tw:disabled:bg-[rgba(167,167,167,0.1)]";
  const fieldInvalidClass = "tw:!border-[#dc3545]";
  const dropdownCaretClass = "tw:inline-block tw:ml-1 tw:border-t-[0.3em] tw:border-x-[0.3em] tw:border-b-0 tw:border-solid tw:border-t-[#dbbe78] tw:border-x-transparent";

  return (
    <FrontLayout>
      <AlertModal
        show={showInvalidCardValidation}
        text={t("checkout.validation.cardValidation")}
        handleClose={handleInvalidCardClose}
      />
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:!bg-[#F9F9F9] tw:mt-12 tw:lg:mt-1 tw:pt-1" ref={formCheckoutRef}>
        <div className="custom-mx">
          <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:!mt-8 tw:lg:w-full tw:lg:flex-none">
            <div className="tw:md:w-2/3 tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-3 tw:mb-4">
              {/* The page arrives in reading order: title, countdown, the form,
                  then the price summary beside it. */}
              <Reveal onMount y={16} className="tw:text-[24px] tw:leading-[40px] tw:!font-[600] tw:pl-2 tw:md:pl-0">
                {t("Billing.Information")}
              </Reveal>
              {showCartCountdown && (
                <Reveal onMount y={12} delay={0.08} className="tw:bg-[#F1F1F1] tw:py-3 tw:px-6 tw:md:mx-0 tw:mx-2 tw:rounded tw:md:w-auto tw:w-full">
                  <div className="tw:flex tw:items-center tw:justify-center tw:gap-2">
                    <ClockAltIcon aria-label="Clock icon" role="img" />
                    <p
                      className="tw:!p-0 tw:!m-0 tw:!text-[14px] tw:!font-[400]"
                      style={{ fontFamily: "var(--font-sans-primary)" }}
                    >
                      {t("NewCheckout.Countdown")}
                    </p>
                    <Clock
                      start={startClock}
                      stop={stopClock}
                      cart={itemsToCheckout}
                      refCallback={SettingClockRef}
                      onCompleteTimer={onCompleteTimer}
                      lastAddedBookToCart={lastAddedBookToCart}
                    />
                  </div>
                </Reveal>
              )}
            </div>
            <div className="tw:flex tw:flex-wrap">
              <Reveal onMount y={24} delay={0.12} className="tw:md:w-2/3 tw:md:flex-none">
                <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)] tw:mb-2 tw:px-6 tw:py-6" >
                  <form>
                    <div className="tw:mb-4">
                      <p className="tw:!text-[16px] tw:!text-[#282828] tw:!font-[500] tw:!mb-0">
                        {t("NewCheckout.PersonalInformation.Title")}{" "}
                        <span className="tw:!text-[#ED553B]">*</span>
                      </p>
                      <p className="tw:!text-[13px] tw:!text-[#7C7B7B] tw:!font-[400] tw:!mb-0">
                        {t("NewCheckout.PersonalInformation.Description")}
                      </p>
                    </div>

                    <hr className={"tw:!border tw:!border-[1px] tw:!border-[#E8E8E8]"}/>

                    <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-[96px_1fr_1fr] tw:gap-4 tw:mb-4">
                      <div data-dropdown>
                        <label className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.Honorifics.Label")}
                        </label>
                        <div className="tw:relative">
                          <button
                            className={`${fieldInputClass} tw:!flex tw:items-center tw:justify-between tw:cursor-pointer tw:select-none`}
                            type="button"
                            onClick={() => setOpenDropdown(openDropdown === "pronounced" ? null : "pronounced")}
                            aria-expanded={openDropdown === "pronounced"}
                            name={"pronounced"}
                          >
                            <span className="tw:!font-[400]">{customerData.pronounced}</span>
                            <span className={dropdownCaretClass}></span>
                          </button>
                          <AnimatePresence>
                          {openDropdown === "pronounced" && (
                          <motion.ul
                            initial={{ opacity: 0, y: -6, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1, transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] } }}
                            exit={{ opacity: 0, y: -4, transition: { duration: 0.14 } }}
                            style={{ transformOrigin: "top" }}
                            className="tw:absolute tw:z-[1000] tw:mt-2 tw:min-w-full tw:overflow-hidden tw:py-1 tw:pl-0! tw:m-0 tw:text-base tw:text-[#212529] tw:list-none tw:bg-white tw:border tw:border-[#EFE6D2] tw:border-t-2 tw:border-t-[#DBBE78] tw:rounded-lg tw:shadow-[0_18px_40px_-12px_rgba(40,40,40,0.28)] tw:left-0 tw:top-full"
                            onClick={() => setOpenDropdown(null)}
                          >
                            {["Mr.", "Ms.", "Mrs."].map((honorific) => (
                              <li
                                key={honorific}
                                className="tw:flex tw:items-center tw:!justify-center tw:w-full tw:py-2 tw:font-normal tw:text-[#212529] tw:whitespace-nowrap tw:no-underline tw:transition-colors tw:hover:bg-[#FBF6EA] tw:cursor-pointer"
                                onClick={() => onChangeForm({ target: { name: "pronounced", value: honorific } })}
                              >
                                {honorific}
                              </li>
                            ))}
                          </motion.ul>
                          )}
                          </AnimatePresence>
                        </div>
                      </div>
                      <div>
                        <label htmlFor="firstName" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.FirstName.Label")}
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          id="firstName"
                          className={`${fieldInputClass} ${firstnamev !== "" ? fieldInvalidClass : ""}`}
                          placeholder={t("NewCheckout.PersonalInformation.FirstName.Placeholder")}
                          aria-label={t("NewCheckout.PersonalInformation.FirstName.Label")}
                          value={customerData.firstName}
                          onChange={(e) => onChangeForm(e)}
                          autoComplete="given-name"
                          style={{
                            color: customerData.firstName ? "#282828" : "",
                            fontWeight: customerData.firstName ? "bold" : "",
                          }}
                        />
                        {firstnamev === "is-invalid-empty" && (
                          <p className="tw:text-[#dc3545]!">
                            {t("businessRegister.validation.billingName")}
                          </p>
                        )}
                        {firstnamev === "is-invalid-min" && (
                          <p className="tw:text-[#dc3545]!">
                            {t("businessRegister.validation.billingNameMinLength")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label htmlFor="lastName" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.LastName.Label")}
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          id="lastName"
                          className={`${fieldInputClass} ${lastnamev !== "" ? fieldInvalidClass : ""}`}
                          placeholder={t("NewCheckout.PersonalInformation.LastName.Placeholder")}
                          aria-label={t("NewCheckout.PersonalInformation.LastName.Label")}
                          value={customerData.lastName}
                          onChange={(e) => onChangeForm(e)}
                          autoComplete="family-name"
                          style={{
                            color: customerData.lastName ? "#282828" : "",
                            fontWeight: customerData.lastName ? "bold" : "",
                          }}
                        />
                        {lastnamev === "is-invalid-empty" && (
                          <p className="tw:text-[#dc3545]!">
                            {t("businessRegister.validation.billingName")}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4 tw:mb-4">
                      <div>
                        <label htmlFor="emailAddress" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.EmailAddress.Label")}
                        </label>
                        <input
                          type="text"
                          className={`${fieldInputClass} ${emailv !== "" ? fieldInvalidClass : ""}`}
                          id="emailAddress"
                          placeholder={t("NewCheckout.PersonalInformation.EmailAddress.Placeholder")}
                          name="email"
                          value={customerData.email}
                          onChange={(e) => onChangeForm(e)}
                          autoComplete="email"
                          style={{
                            color: customerData.email ? "#282828" : "",
                            fontWeight: customerData.email ? "bold" : "",
                          }}
                        />
                        {(emailv === "is-invalid-empty" || emailv === "is-invalid-format") && (
                          <p className="tw:text-[#dc3545]!">
                            {t("Please.enter.a.valid.email.address")}
                          </p>
                        )}
                      </div>
                      <div>
                        <label htmlFor="phoneNumber" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.PhoneNumber.Label")}
                        </label>
                        {/* Dial-code picker + number drawn as one box (same picker as registration). */}
                        <div
                          className={`tw:flex tw:h-12 tw:items-stretch tw:rounded-[0.3rem] tw:border tw:bg-white tw:transition-[border-color,box-shadow] tw:duration-200 tw:focus-within:border-[#DBBE78] tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)] ${phonev !== "" ? "tw:border-[#dc3545]" : "tw:border-[#f1f1f1]"}`}
                        >
                          <CountryCodePicker
                            countryCode={countryCode}
                            dialCode={prefixPhoneNumber}
                            onSelect={handleLiClickCountryList}
                          />
                          <input
                            type="text"
                            className="tw:min-w-0 tw:flex-1 tw:rounded-r-[0.3rem] tw:bg-transparent tw:px-4 tw:text-[15px] tw:text-[#4e4e4e] tw:outline-none tw:[font-family:var(--font-sans-primary)] tw:placeholder:text-[#a7a7a7]"
                            id="phoneNumber"
                            placeholder={t(
                              "NewCheckout.PersonalInformation.PhoneNumber.Placeholder"
                            )}
                            name="phone"
                            value={customerData.phone}
                            onChange={(e) => {
                              // Only allow numeric characters (0-9)
                              const numericValue = e.target.value.replace(/[^0-9]/g, '');
                              // Create a new event object with the filtered value
                              const syntheticEvent = {
                                ...e,
                                target: {
                                  ...e.target,
                                  value: numericValue,
                                  name: "phone"
                                }
                              };
                              onChangeForm(syntheticEvent);
                            }}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            style={{
                              color: customerData.phone ? "#282828" : "",
                              fontWeight: customerData.phone ? "bold" : "",
                            }}
                          />
                        </div>
                        {phonev !== "" && (
                          <p className="tw:text-[#dc3545]!">
                            {t("businessRegister.validation.billingPhoneNumber")}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-4 tw:mb-4">
                      <div>
                        <label htmlFor="country" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.Country.Label")}
                        </label>
                        <input
                          disabled={true}
                          type="text"
                          className={`${fieldInputClass} ${countryv !== "" ? fieldInvalidClass : ""}`}
                          id="country"
                          placeholder={t("NewCheckout.PersonalInformation.Country.Placeholder")}
                          name="country"
                          value={customerData.country}
                          onChange={(e) => onChangeForm(e)}
                          style={{
                            background: "#FBFBFB",
                            color: "#282828",
                            fontWeight: customerData.country ? "bold" : "",
                          }}
                          data-tip
                          data-for="countryTooltip"
                        />
                        <ReactTooltip id="countryTooltip" backgroundColor="#F6EEDC" textColor="#4E4E4E">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: t("registration.country_tooltip"),
                            }}
                          ></span>
                        </ReactTooltip>
                        {countryv !== "" ? <p className="tw:text-[#dc3545]!">{t("Please.enter.your.country")}</p> : ""}
                      </div>
                      <div>
                        <label htmlFor="postCode" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.PostalCode.Label")}
                        </label>
                        <div className="tw:relative">
                        <input
                          min={1}
                          type="text"
                          pattern="[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d"
                          disabled={isPostalCodeDisabled}
                          className={`${fieldInputClass} tw:!pr-10 ${postcodev !== "" || postcodeNotFoundv !== "" ? fieldInvalidClass : ""}`}
                          id="postCode"
                          placeholder={t("NewCheckout.PersonalInformation.PostalCode.Placeholder")}
                          name="postCode"
                          value={customerData.postCode}
                          onChange={(e) => onChangeForm(e)}
                          autoComplete="postal-code"
                          style={{
                            background: isPostalCodeDisabled ? "#FBFBFB" : "",
                            color: customerData.postCode ? "#282828" : "",
                            fontWeight: customerData.postCode ? "bold" : "",
                          }}
                        />
                          <span className="tw:pointer-events-none tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2">
                            <PostalCodeStatusIcon status={postalCodeLookup.status} />
                          </span>
                        </div>
                        <PostalCodeStatusMessage status={postalCodeLookup.status} onRetry={postalCodeLookup.retry} />
                        {postcodev !== "" && <p className="tw:text-[#dc3545]!">{t("businessRegister.validation.billingPostalCode")}</p>}
                        {postcodeNotFoundv !== "" && <p className="tw:text-[#dc3545]!">{t("businessRegister.validation.billingPostalCodeInvalid")}</p>}
                      </div>
                      <div>
                        <label htmlFor="city" className={fieldLabelClass}>
                          {t("NewCheckout.PersonalInformation.City.Label")}
                        </label>
                        <input
                          type="text"
                          disabled={isCityDisabled}
                          className={fieldInputClass}
                          id="city"
                          placeholder={
                            isCheckingPostalCode
                              ? t("PostalCodeStatus.LookingUpCity")
                              : t("NewCheckout.PersonalInformation.City.Placeholder")
                          }
                          name="city"
                          value={customerData.city}
                          onChange={(e) => onChangeForm(e)}
                          autoComplete="address-level2"
                          style={{
                            background: isCityDisabled ? "#FBFBFB" : "",
                            color: customerData.city ? "#282828" : "",
                            fontWeight: customerData.city ? "bold" : "",
                          }}
                        />
                      </div>
                    </div>

                    <div className="tw:mb-12">
                      <label htmlFor="streetAddress" className={fieldLabelClass}>
                        {t("NewCheckout.PersonalInformation.BillingAddress.Label")}
                      </label>
                      <input
                        type="text"
                        className={`${fieldInputClass} tw:max-md:hidden ${addressv !== "" ? fieldInvalidClass : ""}`}
                        id="streetAddress"
                        placeholder={t("NewCheckout.PersonalInformation.BillingAddress.Placeholder")}
                        name="address"
                        value={customerData.address}
                        onChange={(e) => onChangeForm(e)}
                        style={{
                          color: customerData.address ? "#282828" : "",
                          fontWeight: customerData.address ? "bold" : "",
                        }}
                      />
                      <textarea
                        className={`${fieldInputClass} tw:h-20 tw:py-3 tw:resize-none tw:md:hidden ${addressv !== "" ? fieldInvalidClass : ""}`}
                        id="streetAddressMobile"
                        placeholder={t("NewCheckout.PersonalInformation.BillingAddress.Placeholder")}
                        name="address"
                        value={customerData.address}
                        onChange={(e) => onChangeForm(e)}
                        style={{
                          color: customerData.address ? "#282828" : "",
                          fontWeight: customerData.address ? "bold" : "",
                        }}
                      />
                      {addressv !== "" && (
                        <p className="tw:text-[#dc3545]!">
                          {t("businessRegister.validation.billingAddress")}
                        </p>
                      )}
                    </div>

                    {isAuthChecked && (
                      <div className="tw:flex tw:flex-wrap tw:gap-y-4 tw:mb-4">
                        <div className="tw:flex-1 tw:basis-0 tw:grow">
                          <p className="tw:!text-[15px] tw:!text-[#282828] tw:!mb-2 tw:!font-[500]">
                            {t("checkout.paymentMethod.title")}{" "}
                            <span className="tw:!text-[#ED553B]">*</span>
                          </p>
                          {paymentMethods.map((item, index) => (
                            <div
                              className="tw:flex tw:bg-[#f8f9fa] tw:mb-2 tw:py-4 tw:px-4 tw:justify-between tw:rounded-[0.375rem]"
                              key={index}
                            >
                              <div>
                                <div className="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:min-h-[1.5rem] ">
                                  <input
                                    className="tw:w-4 tw:h-4 tw:align-top tw:bg-white tw:border tw:border-[rgba(0,0,0,0.25)] tw:appearance-auto tw:accent-[#282828]"
                                    type="radio"
                                    name="paymentMethod"
                                    id={`paymentMethod${index}`}
                                    checked={item._id === selectedPaymentMethod}
                                    onChange={() => {
                                      setSelectedPaymentMethod(item._id)
                                    }}
                                  />
                                  <label
                                    className="form-check-label-checkout"
                                    htmlFor={`paymentMethod${index}`}
                                  >
                                    <img
                                      src={getCardTypeByBrand(item.brand)}
                                      alt=""

                                      className="tw:mr-2"
                                    />
                                    <span>
                                      {`••••${item.cardNumber.slice(-4)}, ${t("checkout.paymentMethod.field.exp")}: ${String(item.expirationMonth).padStart(2, '0')}/${String(item.expirationYear).slice(-2)}`}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ))}
                          <motion.button
                            type="button"
                            whileHover={pressable.hover}
                            whileTap={pressable.tap}
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:!rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none add-payment-method-checkout tw:rounded-[0.375rem] tw:py-2"
                            onClick={addPaymentMethodHandler}
                          >
                            <div className="tw:flex tw:gap-2 tw:justify-center tw:items-center tw:mx-2">
                              <AddIcon />
                              <span className="tw:!text-[15px]">{t("checkout.paymentMethod.button")}</span>
                            </div>
                          </motion.button>
                        </div>
                      </div>
                    )}

                    <div className="tw:mt-6">
                      <p className="tw:!text-[16px] tw:!text-[#282828] tw:!font-[500] tw:!mb-0">
                        {t("NewCheckout.TermsAndCondition.Title")}{" "}
                        <span className="tw:!text-[#ED553B]">*</span>
                      </p>
                      <div className="tw:bg-[#FFF8E8] tw:p-6 tw:mt-4 tw:!rounded-[0.25rem] tw:relative tw:overflow-hidden">
                        {/* Fills as the terms are read; the checkbox unlocks at the end. */}
                        <ScrollProgressBar containerRef={contentRef} />
                        <div
                          className="tw:overflow-auto custom-scrollbar "
                          ref={contentRef}
                          style={{ height: "381px" }}
                          dangerouslySetInnerHTML={{
                            __html: `${t("termConditionContent")}`,
                          }}
                        ></div>
                      </div>
                      <div className="tw:flex tw:items-center tw:gap-2 tw:block tw:min-h-[1.5rem] tw:mt-6"
                        data-tip
                        data-for="tncTooltip">
                        <input
                          className="tw:w-4 tw:h-4 tw:align-top tw:bg-white tw:border tw:border-[rgba(0,0,0,0.25)] tw:appearance-auto tw:accent-[#A7A7A7]"
                          type="checkbox"
                          id="tnc"
                          checked={isTermsChecked}
                          onChange={handleTermsCheckboxChange}
                          disabled={isScrolledToBottom ? false : true}
                        />
                        <label
                          className={`tw:!text-[15px] ${isScrolledToBottom ? "tw:!text-[#282828]" : "tw:!text-[#A7A7A7]"} ${isTermsChecked ? "tw:!font-[700]" : "tw:!font-[400]"}`} htmlFor="tnc"
                          dangerouslySetInnerHTML={{
                            __html: `${t("NewCheckout.TermsAndCondition.Checkbox")}`,
                          }}
                        >
                        </label>
                        {!isTermsChecked && !isScrolledToBottom &&
                          <ReactTooltip
                            id="tncTooltip"
                            backgroundColor="#4A4A4A"
                            textColor="#FFFFFF"
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t("NewCheckout.TncTooltip"),
                              }}
                            ></span>
                          </ReactTooltip>
                        }
                      </div>
                    </div>
                  </form>
                </div>

                <div className="tw:grid tw:mt-4">
                  <motion.button
                    whileHover={checkoutButtonEligibility() ? pressable.hover : undefined}
                    whileTap={checkoutButtonEligibility() ? pressable.tap : undefined}
                    onClick={(customerData.role === "individual" || customerData.role === "business") ? handleCheckoutConfirmationShow : clickProceedToPayment}
                    type="button"
                    className="tw:!inline-block tw:!leading-normal tw:!text-center tw:!no-underline tw:!align-middle tw:!cursor-pointer tw:!select-none tw:!border tw:!border-transparent tw:!px-3 tw:!py-3 tw:!rounded-[0.25rem] tw:!transition-[color,background-color,border-color,box-shadow] tw:!duration-150 tw:!disabled:opacity-65 tw:!disabled:pointer-events-none tw:!bg-[#d4b055] tw:!text-[#FFFFFF] tw:!font-[700] tw:!text-[15px] tw:!hover:bg-[#c2a86b] tw:!hover:border-[#c2a86b] tw:!hover:opacity-60 tw:!rounded-[0.375rem] tw:!py-2 tw:!hidden tw:!md:block"
                    disabled={!checkoutButtonEligibility()}
                  >
                    <div className="tw:flex tw:gap-2 tw:justify-center tw:items-center">
                      <span>{t("NewCheckout.CheckoutButton")}</span>
                      <ArrowRightIcon
                      color="#FFFFFF"
                      />
                    </div>
                  </motion.button>
                </div>
              </Reveal>
              <Reveal onMount y={24} delay={0.22} className="tw:md:w-1/3 tw:md:flex-none">
                <MultiTotalCard
                  carts={sortedItemsToCheckout}
                  title={t("NewCheckout.Total")}
                  className="tw:ml-0 tw:md:ml-4"
                />
                <div className="tw:mt-6 tw:ml-0 tw:md:ml-4">
                  <div className="tw:w-full tw:flex-none tw:flex tw:items-center tw:justify-center tw:mt-4 tw:px-4">
                    <p className="tw:text-center" dangerouslySetInnerHTML={{ __html: t("Footer.AcceptPaymentMethod") }}></p>
                  </div>
                  <div className="tw:w-full tw:flex-none tw:px-4 tw:md:flex tw:md:justify-center tw:lg:block tw:mb-4">
                    <div className="tw:border-0 tw:mb-4 tw:flex tw:flex-row tw:items-center tw:gap-2">

                      <img alt="img" src={visa_icon} className="tw:max-w-full tw:h-auto" />
                      <img alt="img" src={jcb_icon} className="tw:max-w-full tw:h-auto" />
                      <img alt="img" src={diners_club_icon} className="tw:max-w-full tw:h-auto" />
                      <img alt="img" src={amex_icon} className="tw:max-w-full tw:h-auto" />
                      <img alt="img" src={discover_icon} className="tw:max-w-full tw:h-auto" />
                      <img alt="img" src={maestro_icon} className="tw:max-w-full tw:h-auto" />
                    </div>
                  </div>
                  <div className="tw:w-full tw:flex-none tw:flex tw:items-center tw:justify-center tw:mt-4 tw:px-4">
                    <p className="tw:text-center" dangerouslySetInnerHTML={{ __html: t("Footer.BankTransfer") }}></p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
      <CheckoutConfirmationModal show={checkoutConfirmationShow} onClose={handleCheckoutConfirmationClose} onNext={handleCheckoutConfirmationNext} />
    </FrontLayout>
  );
};

NewCheckout.propType = {
  isAuthenticated: PropTypes.bool,
};

const mapsStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapsStateToProps)(NewCheckout);